export enum Delimiter {
  LineBreak,
  Tabulator,
  Space,
  Comma,
  Semicolon,
  UserDefined
}
